import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';
import Cookie from 'common/services/util/-RFC.Cookie';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$document', '$window', '$rootScope'];

class DwmStoreController {

    constructor($scope, $state, $document, $window, $rootScope) {

        Mixpanel.send('ConnectWeb AIA Store Open');

        $scope.showOPCButton = false;
        $scope.isOneClickPaymentEnable = CWCONFIG.features.oneClickPayment;

        eventManager.subscribe('showRecommendation:true', () => {


            $scope.showOPCButton = true;

        });
        eventManager.subscribe('showRecommendation:false', () => {

            $scope.showOPCButton = false;

        });

        $scope.activeScreen = 'screen-1';

        $scope.changeActiveScreen = (screen, tab) => {

            $scope.activeScreen = screen;

            Mixpanel.send(`ConnectWeb ${tab} Click`);

        };

        $scope.faqs = ['dark_web', 'dark_web_monitoring', 'dark_web_assets', 'dark_web_notifications', 'identity_theft', 'dark_web_technology', 'stolen_wallet'];

        $scope.changeQuestion = (question) => {

            $scope.activeQuestion = question !== $scope.activeQuestion ? question : '';

            Mixpanel.send('ConnectWeb DWM Upsell FAQ', {
                Question: question,
            });

        };

        $scope.backToDashboard = () => {

            if ($rootScope.redirectFromTab === undefined || $rootScope.redirectFromTab === 'dwm') {

                $state.go('root.dashboard.dwm', {
                    tab: 'dwm',
                });

            } else if ($rootScope.redirectFromTab === 'faq') {

                $state.go('root.dashboard.dwm', {
                    tab: 'faq',
                });

            }


        };

        $document.on('scroll', () => {

            $scope.$apply(() => {

                $scope.hasFooterCookie = !Cookie.get(CWCONFIG.cookie.cookiePolicy);

                const pageHeight = angular.element('div#dwm-upsell-v2')[0] && angular.element('div#dwm-upsell-v2')[0].offsetHeight;
                const headerHeight = angular.element('div#header')[0] && angular.element('div#header')[0].offsetHeight;
                const footerHeight = angular.element('div#cma-disclaimer')[0] && angular.element('div#cma-disclaimer')[0].offsetHeight;
                const bannerHeight = angular.element('div#sticky-banner')[0] && angular.element('div#sticky-banner')[0].offsetHeight;

                const minHeight = headerHeight - bannerHeight;
                const maxHeight = pageHeight - (footerHeight + bannerHeight);

                if ($window.scrollY > minHeight && $window.scrollY < maxHeight) {

                    $scope.showStickyBanner = true;

                } else {

                    $scope.showStickyBanner = false;

                }

            });

        });

    }


}


class DwmStoreDirective {

    constructor() {

        this.template = require('./dwm-store.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $state, $document, $window, $rootScope) =>
            new DwmStoreController($scope, $state, $document, $window, $rootScope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'DwmStoreCtrl';

    }

}

_directiveDependencies.push(() => new DwmStoreDirective());


angular.module('directives')
    .directive('dwmStore', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/dwm-store/dwm-store.js